import React, { useState, useEffect } from "react";

import Modal from "react-modal";
import { useMyContext } from "hooks";
import { Body, ModalContainer, CloseButton, StyledImg } from "./styles";

import CloseIcon from "../../../../assets/closeIconWhite.svg";

const CopyLinkModal = ({ body, isOpen, onClose, link }) => {
  const { themeType, t } = useMyContext();

  const copyToClipboard = () => {
    link && navigator.clipboard.writeText(link);
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <Modal
      onClick={handleClose}
      isOpen={isOpen}
      onRequestClose={handleClose}
      onAfterOpen={copyToClipboard}
      style={{
        overlay: {
          backgroundColor: "rgba(51, 51, 51, 0.35)",
        },
        content: {
          position: "absolute",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "60px",
          width: "215px",
          top: "19px",
          left: "auto",
          border: "0",
          right: "8px",
          backgroundColor: "rgba(51, 51, 51, 0)",
        },
      }}
    >
      <ModalContainer>
        <CloseButton themeType={themeType} onClick={handleClose}>
          <StyledImg src={CloseIcon} height="18px" width="18px" />
        </CloseButton>
        <Body themeType={themeType}>{body || t["share:copiedLink"]}</Body>
      </ModalContainer>
    </Modal>
  );
};

export default CopyLinkModal;
